import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
  getWopi360TargetDetails,
  closeWopi360Target,
  sendInvitations
} from '../../ducks/wopi360-target'
import { changeLanguage } from '../../ducks/account'
import { fetchTranslationsForWopi360Questions } from '../../ducks/wopi360-questionnaire'

import Wopi360TargetDetails from '../Wopi360TargetDetails'
import Loading from '../Loading'
import GridContainer from '../GridContainer'
import Wopi360App from '../Wopi360App'

import styles from '../styles/app.scss'

class AnonWopi360TargetDetailsContainer extends Component {
  componentDidMount() {
    const { getWopi360TargetDetails, params: { uuid } } = this.props

    getWopi360TargetDetails(uuid)
  }

  componentWillReceiveProps(nextProps) {
    const { currentLanguage, changeLanguage, fetchTranslationsForWopi360Questions } = this.props

    if (currentLanguage !== nextProps.currentLanguage) {
      fetchTranslationsForWopi360Questions(nextProps.currentLanguage)
      changeLanguage(nextProps.currentLanguage)
    }
  }

  handleCloseTarget = () => {
    const { closeWopi360Target, params: { uuid } } = this.props

    closeWopi360Target(uuid)
  }

  handleLanguageChange = language => {
    const { changeLanguage, fetchTranslationsForWopi360Questions } = this.props

    fetchTranslationsForWopi360Questions(language)
    changeLanguage(language)
  }

  render() {
    const { wopi360TargetDetails, currentLanguage, sentInvitations, sendInvitations } = this.props

    const targetName = wopi360TargetDetails
      ? `${wopi360TargetDetails.givenName} ${wopi360TargetDetails.familyName}`
      : ''

    return (
      <Loading inline={true} isReady={wopi360TargetDetails}>
        <Wopi360App
          currentAccount={null}
          currentLanguage={currentLanguage}
          hideNonAdminLanguages={false}
          onChangeLanguage={this.handleLanguageChange}
          targetName={targetName}
        >
          {wopi360TargetDetails && (
            <GridContainer>
              <div className={styles.app}>
                <Wopi360TargetDetails
                  wopi360TargetDetails={wopi360TargetDetails}
                  currentAccountOption={null}
                  currentLanguage={currentLanguage}
                  sentInvitations={sentInvitations}
                  onCloseTarget={this.handleCloseTarget}
                  onSendInvitations={sendInvitations}
                />
              </div>
            </GridContainer>
          )}
        </Wopi360App>
      </Loading>
    )
  }
}

export default connect(
  state => {
    const wopi360TargetDetails = state.wopi360Target.targetDetails

    const currentLanguage =
      state.account.get('currentLanguage') ||
      (wopi360TargetDetails ? wopi360TargetDetails.language : null)

    return {
      currentLanguage,
      wopi360TargetDetails,
      sentInvitations: state.wopi360Target.sentInvitations
    }
  },
  {
    getWopi360TargetDetails,
    closeWopi360Target,
    changeLanguage,
    sendInvitations,
    fetchTranslationsForWopi360Questions
  }
)(AnonWopi360TargetDetailsContainer)



// WEBPACK FOOTER //
// ./src/components/smart/AnonWopi360TargetDetailsContainer.js